import React from "react";
import ReactDOM from "react-dom";

import Button from "@mui/material/Button";
import SyncIcon from "@mui/icons-material/Sync";

import { showSnack } from "components/GlobalSnackbar";

import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { Environment } from "configs";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorkerRegistration.register({
  onUpdate: (registration: ServiceWorkerRegistration) => {
    setTimeout(() => {
      showSnack("Uma nova versão esta disponível", {
        variant: "info",
        action: () => (
          <Button
            size="small"
            variant="contained"
            color="secondary"
            startIcon={<SyncIcon />}
            onClick={() => {
              registration.waiting?.postMessage({ type: "SKIP_WAITING" });
              window.location.reload();
            }}
          >
            Atualizar
          </Button>
        ),
      });
    }, 1500);
  },
  onSuccess: () => {
    showSnack("Uma nova versão foi instalada", {
      variant: "info",
    });
  },
});

if (Environment.IS_DEV_MODE) {
  // eslint-disable-next-line no-console
  reportWebVitals(console.log);
}
